import * as React from 'react';
import Button, { Props as ButtonProps } from '../Button/Button';
import ProgressButtonContent, { Props as ProgressButtonContentProps } from './ProgressButtonContent';

export interface Props extends ButtonProps, ProgressButtonContentProps { }

/**
 * A progress indicator action button that is useful
 * to provide inline feedback that after a user action,
 * something is happening.
 */
const ProgressButton: React.FunctionComponent<Props> = (props: Props) => {
  const { children, progressing, ...rest } = props;

  return (
    <Button { ...rest }>
      <ProgressButtonContent progressing={ progressing }>
        { children }
      </ProgressButtonContent>
    </Button>
  );
};

export default ProgressButton;
